var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEye = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 11.9996C10.2 11.0055 11.0059 10.1996 12 10.1996C12.9941 10.1996 13.8 11.0055 13.8 11.9996C13.8 12.9937 12.9941 13.7996 12 13.7996C11.0059 13.7996 10.2 12.9937 10.2 11.9996Z",
    fill: "#7E867D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.9996C4 13.3111 4.33997 13.7528 5.01991 14.6361C6.37757 16.4 8.65449 18.3996 12 18.3996C15.3455 18.3996 17.6224 16.4 18.9801 14.6361C19.66 13.7528 20 13.3111 20 11.9996C20 10.6881 19.66 10.2464 18.9801 9.36307C17.6224 7.59926 15.3455 5.59961 12 5.59961C8.65449 5.59961 6.37757 7.59926 5.01991 9.36307C4.33997 10.2464 4 10.6881 4 11.9996ZM12 8.99961C10.3431 8.99961 9 10.3428 9 11.9996C9 13.6565 10.3431 14.9996 12 14.9996C13.6569 14.9996 15 13.6565 15 11.9996C15 10.3428 13.6569 8.99961 12 8.99961Z",
    fill: "#7E867D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Eye.979fff06.svg";
export { ForwardRef as ReactComponent };